import type {PublicMethodUtils} from '@wix/document-services-types'
import type {TransformationsPublicAPI} from '@wix/document-services-public-types'
import {transformations, utils} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<TransformationsPublicAPI> {
    return {
        methods: {
            components: {
                transformations: {
                    update: publicMethodUtils.defineDataManipulationAction(transformations.updateTransformationsData, {
                        isUpdatingAnchors: utils.NO
                    }),
                    get: publicMethodUtils.defineGetter(transformations.getTransformationsData),
                    remove: publicMethodUtils.defineDataManipulationAction(transformations.removeTransformationsData),
                    getAllHiddenComponents: publicMethodUtils.defineGetter(
                        transformations.getAllHiddenComponentsByVariants
                    ),
                    getAllHiddenComponentsByDefault: publicMethodUtils.defineGetter(
                        transformations.getAllHiddenComponentsByDefault
                    ),
                    setPropsToIgnore: publicMethodUtils.defineAction(transformations.setPropsToIgnore),
                    setGlobalPropsToIgnore: publicMethodUtils.defineAction(transformations.setGlobalPropsToIgnore),
                    setPropsToIgnoreForType: publicMethodUtils.defineAction(transformations.setPropsToIgnoreForType)
                }
            }
        }
    }
}
